export const PORTFOLIO_PROJECTS_DIALOG_TABLE_KEY = 'PORTFOLIO_PROJECTS_DIALOG';
